<template>
	<v-card 
		outlined
	>
		<v-card-title
			class = "pa-0 secondary body-2 justify-center white--text"
		>
			<v-icon
				small
				color  = "white"
				class  = "mx-1"
				v-text = "'mdi-database'"
			></v-icon>
			<span
				v-text = "$ml.get('disks')"
			></span>
			<v-btn
				fab
				right
				x-small
				absolute
				class  = "mt-10 mr-5"
				:color = "!show ? 'blue darken-1' : 'error'"
				@click = "actions('show')"
				v-show = "shows.add_disk"

			>
				<v-icon
					x-small		
					color = "white"					
				>
					{{ !show ? 'mdi-plus' : 'mdi-close'}}
				</v-icon>
			</v-btn>
		</v-card-title>
		<v-card-text
			class = "pa-1"
		>
			<v-row
				dense
			>
				<!-- 3 -->
				<v-col 									
					xl   = "2"
					lg 	 = "3"
					md 	 = "3"
					sm 	 = "12"
					xs   = "12"
					cols = "12"
					v-show  = "show"
				>
					<v-card 
						outlined
					>
						<v-card-title
							class = "primary pa-0 pl-2 body-1 white--text"
						>
							<span> {{ $ml.get(title) }}</span>
						</v-card-title>	
						<v-card-text
							class = "pa-1 mt-1"
						>
							
							<v-row
								dense
							>
								<template v-for = "(item_info, idx_info) of info_fields">
									
									<v-col 
										:key = "idx_info"
										xl   = "12"
										lg 	 = "12"
										md 	 = "12"
										sm 	 = "12"
										xs   = "12"
										cols = "12"
									>
										<v-text-field
											outlined
											dense
											hide-details
											v-if 		 = "item_info.type == 'text' || item_info.type == 'number'"
											v-model 	 = "info[item_info.key]"
											:type 		 = "item_info.type"
											:label 		 = "$ml.get(item_info.text)"
											:placeholder = "item_info.placeholder"
											@click 		 = "$Helper.keyboard_is_active(item_info.key, ID_notification, 'obj', 'info')"
										></v-text-field>
											<!-- @input 		 = "info[item_info.key] = input[item_info.key]" -->
										<v-select
											outlined
											dense
											hide-details
											v-if 		 = "item_info.type == 'select'"
											v-model 	 = "info[item_info.key]"								
											:items 		 = "item_info.list"										
											:label 		 = "$ml.get(item_info.text)"
											:placeholder = "item_info.placeholder"
										></v-select>
										<!-- text-value 	 = "name"
											key-value    =  -->
										<v-card outlined 
											class  	  = "pa-0 caption pb-1" 
											height 	  = "40"
											v-else-if = "item_info.type == 'switch'"
										>
											<v-switch			
												dense						
												false-value
												hide-details
												class 			= "mt-1"			
												v-model 		= "info[item_info.key]"						
												:label 			= "$ml.get(item_info.text)"
												:prepend-icon 	= "item_info.icon"
											></v-switch>
												<!-- v-if="item_field.type == 'switch'"						 -->
												<!-- class="pt-0" -->
										</v-card>
									</v-col>
								</template>
							</v-row>
						</v-card-text>
						<v-divider></v-divider>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn
								x-small
								color 	= "primary"
								@click 	= "actions(action_title, info_item)"							
							>
								{{ action_title }}
							</v-btn>
							<v-btn
								x-small
								color 	= "error"
								@click 	= "actions('close_show')"							
								v-text  = "$ml.get('close')"
							></v-btn>
						</v-card-actions>
					</v-card>
				</v-col>
				<v-col>
					<v-toolbar						    		
				    		dense
				    		height = "25"
				    		class  = "secondary white--text"
				    	>
				    	<v-icon
							small
							color = "white"
							class = "mr-1"
						>
							mdi-view-list
						</v-icon>
				    	<v-toolbar-title 
				    		class = "body-2"
				    	> 
				    		{{ $ml.get('registered_disks') }}
				    	</v-toolbar-title>
				    </v-toolbar>
						
					<v-divider></v-divider>
					<v-data-table
						dense
					    fixed-header
					    :headers 			 = "headers"
					 	:items 				 = "render_list"
					    class 				 = "elevation-5"			    
					    :hide-default-footer = "height < 56 ?  true : false"
					   	:options.sync 		 = "options"
					   	:server-items-length = "total"
					    :height 			 = "height+'px'"
					    item-key 			 = "index"
					    :loading 			 = "loading"
					   	:footer-props 		 = "{
					   		showFirstLastPage 	: true,
					   		itemsPerPageOptions : [15, 30],
					   		showCurrentPage 	: true
					   	}"				   	
					>	
						<template v-slot:item.size = "{ item }">
							<span>
								{{ item.size }}  <strong class = "primary--text">GB</strong>
							</span>							
						</template>
						<template v-slot:item.limit = "{ item }">
							<span>
								{{ item.limit }}  <strong class = "primary--text">GB</strong>
							</span>										
						</template>
						<template  v-slot:item.actions="{ item }">
							<v-icon
						        small
						        color  = "primary"
						        class  = "mr-2"
						        @click = "actions('edit', item)"
						        v-show = "shows.edit_disk"
						      >
						        mdi-pencil
						    </v-icon>
						    <v-icon
						        small
						        color  = "error"
						        @click = "actions('del', item)"
						        v-show = "shows.delete_disk"
						    >
						        mdi-delete
						    </v-icon>
						</template>
					</v-data-table>
				</v-col>
				<v-col 
					xl   = "12"
					lg   = "12"
					md   = "12"
					sm   = "12"
					xs   = "12"
					cols = "12"
					v-if = "shows.records"
				>
					<records
					></records>
				</v-col>
			</v-row>
		</v-card-text>
		
	</v-card>
</template>
<script>
	import EventBus from '@/event-bus'
	import records 	from '@/components/general_parameters/records.vue' 
	export default{
		name 		: 'Disks',
		props 		: ['info_to_component'],
		components  : {
			records
		},
		data 	 	: (vm) => ({
			show 		 : false,
			title 		 : 'new',
			action_title : 'save',
			info 		 : {},
			info_item 	 : {},
			input 		 : {},
			info_fields  : [
				{
					key  		: 'path',
					text 		: 'folder',
					text1 		: '',
					placeholder : '/opt/alice-media',
					type 		: 'text',
					enable 		: true,

				},
				{
					key  		: 'size',
					text 		: 'size',
					text1 		: '',
					placeholder : 'GB',
					type 		: 'number',
					enable 		: true,

				},
				{
					key  	: 'type',
					text 	: 'type',
					text1 	: '',
					type 	: 'select',
					enable 	: true,
					list    : ['media'], // 'evidences', 'videos', 'local',

				},
				{
					key  		: 'limit',
					text 		: 'limit',
					text1 		: '',
					placeholder : 'GB', 
					type 		: 'number',
					enable 		: true,

				},
				{
					key  	: 'status',
					text 	: 'status',
					text1 	: '',
					type 	: 'switch',
					enable 	: true,

				},
				{
					key  	: 'state',
					text 	: 'state',
					text1 	: '',
					type 	: 'switch',
					enable 	: true,

				},
			],

			headers 	: [
				{
					text  : 'folder',
					value : 'path',
				},
				{
					text  : 'size',
					value : 'size',
				},
				{
					text  : 'type',
					value : 'type',
				},
				{
					text  : 'limit',
					value : 'limit',
				},
				{
					text  : 'status',
					value : 'status',
				},
				{
					text  : 'state',
					value : 'state',
				},
				{
					text  : 'actions',
					value : 'actions'
				}
			],
			height			: 250,
			options 		: { itemsPerPage : 30},
			total 			: 0,
			list 			: [],
			loading			: false,
			ID_notification : 'disks',
			shows  			: {
				records 	: false,
				add_disk  	: true,
				edit_disk  	: true,
				delete_disk : true,

			},
		}) , // data 

		watch : {
			options : {
				handler(){
					this.get_list();
				}, deep: true,
			}
		}, // watch

		created(){
			// this.get_folder();
			this.render_info_obj();
			if (this.$store.state.auth.user){
				if(this.$store.state.auth.user.user.roleId == 1){
		       
		      		if (this.$route.name == 'parameters') {
		      			this.shows.records = false;
		      		}
		      	}
		    }
		    let modul = this.$store.getters["auth/permission"](this.$route.name || "settings", "", "settings");
		    if (modul) {		    	
			    if (!modul.can_add) { this.shows.add_disk = false }
			    if (!modul.can_edit) {this.shows.edit_disk = false }
			    if (!modul.can_delete) { this.shows.delete_disk = false }
		    }

		}, // created

		computed : {
			render_list: function(){
				return this.list;
			}, // render list

			currentUser(){
				return this.$store.state.auth.user;
			}, // currentUser
		}, // computed

		methods : {

			actions(act, item, opt){
				console.log("Action : ", act);
				switch (act){
					case 'new' : {

					};
					break;
					case 'show' : {
						this.show = !this.show;
						if (this.action_title == 'update') {
							this.action_title = 'save';
							this.info = {};
						}
					}
					break;
					case 'close_show' : {

						this.show = false;
						this.info = {};
					};
					break;
					case 'save' : {
						this.save();
					};
					break;
					case 'update' : {
						this.update(item);
					};
					break;
					case 'edit' : {
						this.action_title 	= 'update';
						this.show 			= true;
						this.info 			= item;
						this.info_item		= item;
					};
					break;
					case 'del' : {
						this.info_item 		= item;
						EventBus.$emit('notifications_modal', {
							type : 'confirm_delete',
							ID 	 : this.ID_notification,
						});
					};
					break;
					default: 
						console.log("No its options Default")
				};

			}, // actions
			render_info_obj(){
				let obj_new =  this.$Helper.set_property_obj(this.info_fields);
				if (obj_new) {
					this.info = obj_new;
				}
			},

			get_list(){
				const { page, itemsPerPage  } = this.options;
				let pg 	= 1, 
					sw 	= 0;

				this.loading = true;

				if (itemsPerPage==15) {
					if (page % 2 == 0) {
						pg = (page/2);
						sw = 2;
					}else{
						pg = parseInt(page / 2) + 1;
						sw = 1;
					}
				}else{
					pg = page
				}

				const api = this.$URL + '/api/v1/disks/?page=' + pg;
				this.$axios.get(api).then( res => {
					console.log("Get disks ", res.data);
					let items  = res && res.data && res.data.rows ? res.data.rows : null;
					let count  = res && res.data ? res.data.count : 1; 
					this.total = parseInt(count);
					
					if (items) {

						if (itemsPerPage <= 15) {
							if (sw == 1) {
								items = items.slice((sw - 1) * itemsPerPage, sw  + itemsPerPage );
							}else if (sw == 2) {
								items = items.slice(15, 30);
							}
						}			
						items.forEach( item => {
							if (item){

								if (item.size) {
									item.size = this.convert_unit('GB', item.size);
								}

								if (item.limit) {
									item.limit = this.convert_unit('GB', item.limit);
								}
							}
						});	

						this.list = items;
					}
					this.loading = false;
				}).catch( er => {
					console.log("Error "  + this.ID_notification, er);
					this.loading = false;
				})
			}, // get list

			get_folder(){
				const api = this.$URL + '/api/v1/parameters/folders';
				this.$axios.get(api).then( res => {
					console.log("Get folders ", res.data);
				}).catch( er => {
					console.log("Error folder ", er);
				})
			}, // get folder

			save(){
				if (!this.$store.getters["auth/permission"](this.$route.name || "settings", "can_add", "settings")){
					this.$EventBus.$emit("notifications_modal",{
						type 	: "warning",
						message : this.$ml.get("no_have_permission_create") + " : " + this.$ml.get("settings"),
					});
					return false;
				};
				let info_temp 	= this.info;
				let info_up 	= {
					path	: info_temp.path,
					type	: info_temp.type,
					status	: info_temp.status ? info_temp.status : 'Active',
					state 	: info_temp.state,
					size 	: this.convert_unit('B', info_temp.size),
					limit 	: this.convert_unit('B', info_temp.limit)
				};


				/*info_up.size 	= this.convert_unit('B', info_up.size);
				info_up.limit 	= this.convert_unit('B', info_up.limit);*/

				this.loading 	= true;

				const api = this.$URL + '/api/v1/disks';

				this.$axios.post(api, info_up).then( res => {
					console.log("create " + this.ID_notification + ": ", res.data);
					
					let info_res = res && res.data ? res.data : null;  

					
					if (info_res) {

						if (this.list && this.list.length > 0) {
							this.total = this.list.length + 1;
						}else{
							this.total = 1;
						}
						info_res.size 	= this.convert_unit('GB', info_up.size);
						info_res.limit 	= this.convert_unit('GB', info_up.limit);
						
						this.list.push(info_res);
						this.show 	 = false;
						this.info 	 = {};
						
						EventBus.$emit('notifications_modal', {
							type : 'saved'
						});
					}else{
						EventBus.$emit('notifications_modal', {
							type 	: 'error',
							message : 'Not saved'
						});
					}
					this.loading = false;					
					

				}).catch( er => {
					console.log("Error "  + this.ID_notification, er);

					EventBus.$emit('notifications_modal', {
						type 	: 'error',
						message : er && er.message ? er.message : 'Save'
					});
					this.loading = false;
				})
			}, // save

			update(item){
				if (!this.$store.getters["auth/permission"](this.$route.name || "settings", "can_edit", "settings")){
					this.$EventBus.$emit("notifications_modal",{
						type 	: "warning",
						message : this.$ml.get("no_have_permission_edit") + " : " + this.$ml.get("settings"),
					});
					return false;
				};
				let ID 			= item && item.id ? item.id : null;
				
				if (ID) {

					let info_temp 	= this.info;
					let info_up 	= {
						path	: info_temp.path,
						type	: info_temp.type,
						status	: info_temp.status ? info_temp.status : 'Active',
						state 	: info_temp.state,
						size 	: this.convert_unit('B', info_temp.size),
						limit 	: this.convert_unit('B', info_temp.limit)
					};

					
					this.loading 	= true;

					const api = this.$URL + '/api/v1/disks/' + ID;
					
					this.$axios.put(api, info_up).then( res => {
						console.log("Get disk ", res.data);
						EventBus.$emit('notifications_modal', {
							type : 'updated'
						});

						const idx = this.list.indexOf(item);

						/*info_up.size 	= this.convert_unit('GB', info_up.size);
						info_up.limit 	= this.convert_unit('GB', info_up.limit);*/
						this.action_title = 'save';

						this.$nextTick(()=>{

							this.list.splice(idx, 1, info_temp);

							this.info 		= {};
							this.loading    = false;
							this.show 		= false;
						});

					}).catch( er => {
						console.log("Error disk " + this.ID_notification, er);
						EventBus.$emit('notifications_modal', {
							type 	: 'error',
							message : er && er.message ? er.message : 'Update'
						});
						this.loading = false;
					})
				}else{
					console.warn("Error update " + this.ID_notification + " ID : ", ID );
				}
			}, // update			

			del(item){
				if (!this.$store.getters["auth/permission"](this.$route.name || "settings", "can_delete", "settings")){
					this.$EventBus.$emit("notifications_modal",{
						type 	: "warning",
						message : this.$ml.get("no_have_permission_delete") + " : " + this.$ml.get("settings"),
					});
					return false;
				};
				let ID = item && item.id ? item.id : null;

				if (ID) {

					const api = this.$URL + '/api/v1/disks/' + ID;
					this.$axios.delete(api).then( res => {

						EventBus.$emit('notifications_modal', {
							type : 'deleted'
						});

						const idx = this.list.indexOf(item);

						

						this.list.splice(idx, 1);						
						this.total --;
						this.loading    = false;
						
						

					}).catch( er => {
						console.log("Error delete disk " + this.ID_notification, er);
						EventBus.$emit('notifications_modal', {
							type 	: 'error',
							message : er && er.message ? er.message : 'Delete'
						});
						this.loading = false;
					});
				}else{
					console.warn("Error del " + this.ID_notification + " ID : ", ID );
				}
			
			}, // del

			convert_unit(unit, value){
				if (unit == 'GB') {
					// return unit bytes to GB
					return  parseFloat( value / 1073741824).toFixed(2) ;
				}
				if (unit == 'B') {
					// return unit  GB to bytes 
					return parseFloat( 1073741824 * value).toFixed(2);
				}
				return null;
			}, // conver_unit

		}, // methods

		

		mounted(){
			EventBus.$on('notifications_modal' + this.ID_notification ,(action) => {				
				if (action) {
					this.del(this.info_item);
				}				
			});

			EventBus.$on('keyboard_type' + this.ID_notification, (action) =>{
				if (action) {
					console.log("INPUT TYPE : ",action)
					if (action.setting) {
						let { obj, key, type } =  action.setting;
						console.log("this[obj][key]", this.input[key]);
						if (type == 'text') {
							this[key] = action.input;
						}else{
							this[obj][key] = action.input;
							
						}
					}
				}
			});

		}, // mounted
	}; 
</script>